import { Injectable } from '@angular/core';
import { PaymentPlanCommand, PaymentPlanDto, PaymentPromiseDto } from '../models/payment.model';
import { CaseHistoryEntryDto } from '../models/collection-case.model';

@Injectable({ providedIn: 'root' })
export class PaymentMockStateService {
  private readonly createdPromises: PaymentPromiseDto[] = [];
  private readonly plans = new Map<string, PaymentPlanDto>();
  private readonly planHistory = new Map<string, CaseHistoryEntryDto[]>();
  addPromise(promise: PaymentPromiseDto): void { this.createdPromises.push(promise); }
  getPromises(caseId?: string): PaymentPromiseDto[] {
    return this.createdPromises.filter(p => !caseId || p.caseId === caseId);
  }
  hasActivePromise(caseId: string): boolean {
    return this.createdPromises.some(p => p.caseId === caseId && p.status === 'ACTIVE');
  }

  getPaymentPlan(caseId: string): PaymentPlanDto | null { return this.plans.get(caseId) ?? null; }
  getPaymentPlans(caseId?: string): PaymentPlanDto[] {
    const values = [...this.plans.values()];
    return caseId ? values.filter(p => p.caseId === caseId) : values;
  }
  createPaymentPlan(command: PaymentPlanCommand): PaymentPlanDto {
    const plan: PaymentPlanDto = { ...command, derogation: command.derogation ?? false, status: 'ACTIVE' };
    this.plans.set(command.caseId, plan);
    const entry: CaseHistoryEntryDto = {
      entryId: `HIST-PLAN-${Date.now()}`, entryDate: new Date().toISOString(),
      actor: 'Agent (session)', action: 'PAYMENT_PLAN_ACTIVATED',
      details: `${command.installmentCount} échéances — ${command.totalAmount.toFixed(2)} MAD`,
    };
    this.planHistory.set(command.caseId, [entry, ...(this.planHistory.get(command.caseId) ?? [])]);
    return plan;
  }
  getPlanHistory(caseId: string): CaseHistoryEntryDto[] { return this.planHistory.get(caseId) ?? []; }
}
